import {
  DEFAULT_AXIS_LABEL_FONT_SIZE,
  DEFAULT_FONT_WEIGHT
} from "constants/chart.constants";
import { createEntityState } from "entities/charts/factory";
import { ChartOption } from "entities/charts/options";
import { EvaChartStates } from "types/factory";

import { getMosaicLabels } from "components/charts/utils/getMosaicLabels";
import {
  MOSAIC_GRID_LEFT,
  MOSAIC_GRID_RIGHT,
  createColorMap,
  formatSeriesData
} from "components/charts/utils/mosaicUtils";

import { formatChartTitleWithSubscript } from "./utils";

export function translateMosaicResponseToOptions(states: Partial<EvaChartStates>) {
  const { title, layout, series, width, entityKind, chartType } = states;

  const colorList = createColorMap(series);
  const data = formatSeriesData(series, colorList);
  const max = Math.max(...series.map((s) => s.x[1]));
  const labelsToUse = getMosaicLabels(
    series,
    layout,
    width,
    MOSAIC_GRID_RIGHT,
    MOSAIC_GRID_LEFT
  );
  let options = createEntityState(ChartOption.Chart, {
    chartType,
    grid: { top: 92, bottom: 46, left: MOSAIC_GRID_LEFT, right: MOSAIC_GRID_RIGHT },
    toolbox: {
      show: false
    },
    aria: null,
    title: {
      ...createEntityState(ChartOption.Title, {
        text: formatChartTitleWithSubscript(title),
        itemGap: 0,
        subtext: null,
        padding: [14, 0, 10, 16]
      })
    },
    yAxis: {
      ...createEntityState(ChartOption.YAxis, {
        min: 0,
        max: 100,
        name: formatChartTitleWithSubscript(`${entityKind} Count (%)`),
        nameLocation: "middle",
        nameGap: 40,
        nameTextStyle: null,
        nameTruncate: { maxWidth: 520.2, ellipsis: "..." },
        axisLine: {
          onZero: false,
          lineStyle: { color: "rgb(155,155,155)", width: 1 }
        },
        splitLine: {
          lineStyle: {
            color: "#D9D9D9"
          }
        }
      })
    },
    xAxis: [
      {
        ...createEntityState(ChartOption.XAxis, {
          type: "value",
          name: formatChartTitleWithSubscript(layout.xAxis.title),
          min: 0,
          max: max,
          nameLocation: "middle",
          id: "xAxis",
          nameGap: 30,
          axisLine: {
            onZero: false,
            lineStyle: { color: "rgb(155,155,155)", width: 1 }
          },
          splitLine: {
            lineStyle: {
              color: "#D9D9D9"
            }
          },
          axisLabel: {
            color: "#5B6770",
            fontWeight: DEFAULT_FONT_WEIGHT,
            fontSize: DEFAULT_AXIS_LABEL_FONT_SIZE,
            customValues: labelsToUse.map((l) => l.value),
            formatter: (val) => {
              const found = labelsToUse.findIndex((x) => x.value == val);
              if (found >= 0) {
                return labelsToUse[found].label;
              }
              return "";
            }
          },
          axisTick: {
            customValues: labelsToUse.map((l) => l.value)
          },
          position: "bottom"
        })
      },

      {
        nameGap: 30,
        id: "xAxis2",
        type: "value",
        min: 0,
        max: max,
        name: `${entityKind} Count`,
        nameLocation: "middle",
        axisTick: {
          show: false
        },
        position: "top",
        axisLabel: {
          color: "#5B6770",
          fontWeight: DEFAULT_FONT_WEIGHT,
          fontSize: DEFAULT_AXIS_LABEL_FONT_SIZE
        }
      }
    ],
    series: {
      ...createEntityState(ChartOption.MosaicSeries, {
        data: data,
        label: {}
      })
    }
  });

  if (series.length === 0) {
    options = {};
  }
  return options;
}
